import React, { Suspense, useEffect, useState, lazy , createContext, useContext} from "react";

// Libraries
import { Routes, Route, useLocation , Navigate} from "react-router-dom";
import retina from "retinajs";
import { AnimatePresence } from "framer-motion";

// Context
import GlobalContext from "./Context/Context";

// Components
import ScrollToTopButton from "./Components/ScrollToTop";

// Home
import Home from "./Pages/Home";
import ContactUs from "./Pages/ContactUs";
import Individuals from "./Pages/Individuals";
import Businesses from "./Pages/Businesses";
import Blog from "./Pages/Blog";
import EmployeeDetail from "./Pages/EmployeeDetail";
import LoginRegister from "./Pages/LoginRegister";
//import SignupSuccess from "./Pages/SignupSuccess";
import WriteReview from "./Pages/WriteReview";
import ReviewForm from "./Pages/ComponentPage/ReviewForm";
import Profile from "./Pages/ComponentPage/Profile";
import AuthSuccess from "./Functions/AuthSuccess";
// import DownloadPdf from "./Pages/ComponentPage/DownloadPdf";
import Privary from "./Pages/Privary";
import TermPolicy from "./Pages/TermPolicy";
 import Feeds from "./Pages/Feeds";
import Chatbot from "./Pages/ComponentPage/Chatbot";
import SearchResult from "./Pages/ComponentPage/SearchResult";
import ThemeDesign from "./Pages/ThemeDesign";
import FilterSearch from "./Pages/ComponentPage/FilterSearch";
import CopyLink from "./Pages/ComponentPage/CopyLink";
import EmployeeDetailNew from "./Pages/EmployeeDetailPages/EmployeeDetail";
import SearchFilterBus from "./Pages/ComponentPage/SearchFilterBus";
//Employeer Routes
import BusinessLoginRegister from "./Pages/BusinessLoginRegister";
import BusinessForm from "./Pages/ComponentPage/BusinessForm";
import BusinessReviews from "./Pages/BusinessReviews";
import ExpirelinkPopup from "./Pages/ComponentPage/ExpirelinkPopup";
import AccountSettings from "./Pages/ComponentPage/AccountSettings";
import BusinessSettings from "./Pages/ComponentPage/BusinessSettings";
import { initGtag } from './Functions/gtag';
import { initLinkedInTag } from './Functions/linkedin';
import BlogStandardPostPage from './Components/Blogs/PostTypes/BlogStandardPostPage';
import SessionManager from './Functions/SessionManager';
import BlogEditor from "./Pages/BlogEditor";
const NotFoundPage = lazy(() => import("./Pages/404"));


// Create Auth Context
const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check if user is authenticated (e.g., check token in localStorage)
    const token = localStorage.getItem("jwt_token_jobcritic"); // Replace with your auth logic
    if (token) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};

// PrivateRoute Component to protect routes
const PrivateRoute = ({ element, ...rest }) => {
  let { isAuthenticated } = useContext(AuthContext);
  const token = localStorage.getItem("jwt_token_jobcritic");
  if (token) {
    isAuthenticated = true;
  }

  const location = useLocation();

  return isAuthenticated ? (
    element
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

// ProtectedLogin Component to redirect authenticated users
const ProtectedLogin = ({ element }) => {
  const { isAuthenticated } = useContext(AuthContext);
  return isAuthenticated ? <Navigate to="/profile" replace /> : element;
};

function App() {
  const [headerHeight, setHeaderHeight] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [customModal, setCustomModal] = useState({
    el: null,
    isOpen: false,
  });
  const location = useLocation();

  // RetinaJS
  useEffect(() => {
    initGtag();
    initLinkedInTag();
    window.addEventListener("load", retina(document.querySelectorAll("img")));
  }, []);

  useEffect(() => {
    setTimeout(() => {
      import("./Functions/Utilities").then((module) => {
        module.SetHeaderMenuPos();
        module.setDocumentFullHeight();
      });
    }, 1000);
  }, [location]);

  useEffect(() => {
    if (isModalOpen === true) {
      document.querySelector("body").classList.add("overflow-hidden");
    } else {
      document.querySelector("body").classList.remove("overflow-hidden");
    }
  }, [isModalOpen]);

  // Get the current location and set the window to top
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
    setFooterHeight(0);
    setCustomModal({
      ...customModal,
      el: null,
      isOpen: false,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <AuthProvider>
      <SessionManager />
    <GlobalContext.Provider
      value={{
        headerHeight,
        setHeaderHeight,
        footerHeight,
        setFooterHeight,
        isModalOpen,
        setIsModalOpen,
        customModal,
        setCustomModal,
      }}
    >
      <div className="App" style={{ "--header-height": `${headerHeight}px` }}>
        {
          <main style={{ marginTop: headerHeight, marginBottom: footerHeight }}>
            <ScrollToTopButton />
            <AnimatePresence mode="wait">
              <Suspense fallback={<></>}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route
                    path="/privacy"
                    element={
                      <Privary style={{ "--base-color": "#374162" }} />
                    }
                  />
                   <Route path="blog-post">
                      <Route
                        path=":id"
                        element={
                          <BlogStandardPostPage
                            style={{ "--base-color": "#0038e3" }}
                          />
                        }
                      />
                    </Route>
                   <Route
                    path="/term_policy"
                    element={
                      <TermPolicy style={{ "--base-color": "#374162" }} />
                    }
                  />
                  <Route
                    path="/chatbot"
                    element={
                      <Chatbot style={{ "--base-color": "#374162" }} />
                    }
                  />
                  <Route
                    path="/for_individuals"
                    element={
                      <Individuals style={{ "--base-color": "#374162" }} />
                    }
                  />
                  <Route
                    path="/for_businesses"
                    element={
                      <Businesses style={{ "--base-color": "#374162" }} />
                    }
                  />
                  <Route
                    path="/blogs"
                    element={
                      <Blog style={{ "--base-color": "#374162" }} />
                    }
                  /><Route
                  path="/blogs_editor"
                  element={
                    <BlogEditor style={{ "--base-color": "#374162" }} />
                  }
                />
                    <Route
                    path="/professionals"
                    element={
                      <Individuals style={{ "--base-color": "#374162" }} />
                    }
                  />
                  <Route
                    path="/organizations"
                    element={
                      <Businesses style={{ "--base-color": "#374162" }} />
                    }
                  />
                  <Route
                    path="/search_result"
                    element={
                      <SearchResult style={{ "--base-color": "#374162" }} />
                    }
                  />
                   <Route
                    path="/contact_us"
                    element={
                      <ContactUs style={{ "--base-color": "#374162" }} />
                    }
                  />
                  <Route path="/theme-design" element={<ThemeDesign />} />
                  <Route
                    path="/auth-success"
                    element={
                      <AuthSuccess style={{ "--base-color": "#374162" }} />
                    }
                  />
                  <Route
                    path="/profile"
                    element={<PrivateRoute element={<EmployeeDetail style={{ "--base-color": "#374162" }} />} />}
                  />
                  {/* <Route
                    path="/profile"
                    element={
                      <EmployeeDetail style={{ "--base-color": "#374162" }} />
                    }
                  /> */}
                  {/* <Route
                    path="/profile/:name/:id"
                    element={<PrivateRoute element={<EmployeeDetailNew style={{ "--base-color": "#374162" }} />} />}
                  /> */}
                  
                  <Route
                    path="/profile/:name/:id"
                    element={
                      <EmployeeDetailNew style={{ "--base-color": "#374162" }} />
                    }
                  />
                  <Route
                    path="/reviews"
                    element={<PrivateRoute element={<WriteReview style={{ "--base-color": "#374162" }} />} />}
                  />
                  {/* <Route
                    path="/reviews"
                    element={
                      <WriteReview style={{ "--base-color": "#374162" }} />
                    }
                  /> */}
                  <Route
                    path="/review/:id"
                    element={<PrivateRoute element={<ReviewForm style={{ "--base-color": "#374162" }} />} />}
                  />

                  {/* <Route
                    path="/review/:id"
                    element={
                      <ReviewForm style={{ "--base-color": "#374162" }} />
                    }
                  /> */}
                  <Route
                    path="/settings"
                    element={<PrivateRoute element={ <Profile style={{ "--base-color": "#374162" }} />} />}
                  />
                  

                  {/* <Route
                    path="/settings"
                    element={
                      <Profile style={{ "--base-color": "#374162" }} />
                    }
                  /> */}
                  <Route
                    path="/get-more-rating/:id"
                    element={<PrivateRoute element={<CopyLink style={{ "--base-color": "#374162" }} />} />}
                  />
                   {/* <Route
                    path="/get-more-rating/:id"
                    element={
                      <CopyLink style={{ "--base-color": "#374162" }} />
                    }
                  /> */}
                  {/* <Route
                    path="/search"
                    element={<PrivateRoute element={<FilterSearch style={{ "--base-color": "#374162" }} />} />}
                  /> */}
                   {/* <Route
                    path="/search-employee"
                    element={<PrivateRoute element={<SearchFilterBus style={{ "--base-color": "#374162" }} />} />}
                  /> */}
                   <Route
                    path="/search"
                    element={
                      <FilterSearch style={{ "--base-color": "#374162" }} />
                    }
                  />
                   <Route
                    path="/search-employee"
                    element={
                      <SearchFilterBus style={{ "--base-color": "#374162" }} />
                    }
                  />
                   {/* <Route
                    path="/download_pdf"
                    element={
                      <DownloadPdf style={{ "--base-color": "#374162" }} />
                    }
                  /> */}
                  
                   <Route
                    path="/feeds"
                    element={
                      <Feeds style={{ "--base-color": "#374162" }} />
                    }
                  />
                  
                  <Route
                    path="/login"
                    element={
                      <LoginRegister style={{ "--base-color": "#374162" }}  />
                    }
                  />
                
                   <Route
                    path="/expire_link"
                    element={
                      <ExpirelinkPopup style={{ "--base-color": "#374162" }} isOpen={true} loading={false} />
                    }
                  />
                  <Route
                    path="/business-login"
                    element={
                      <BusinessLoginRegister style={{ "--base-color": "#374162" }} />
                    }
                  />
                  <Route
                    path="/business-form"
                    element={
                      <BusinessForm style={{ "--base-color": "#374162" }} />
                    }
                  />
                  <Route
                    path="/verifications"
                    element={
                      <BusinessReviews style={{ "--base-color": "#374162" }} />
                    }
                  />
                  <Route
                    path="/account-settings"
                    element={
                      <AccountSettings style={{ "--base-color": "#374162" }} />
                    }
                  />
                  <Route
                    path="/business-settings"
                    element={
                      <BusinessSettings style={{ "--base-color": "#374162" }} />
                    }
                  />
                  <Route path="*" element={<NotFoundPage />} />
                  
                </Routes>
              </Suspense>
            </AnimatePresence>
          </main>
        }
      </div>
    </GlobalContext.Provider>
    </AuthProvider>
  );
}

export default App;
